import ModelUtil from '@leverege/model-util';
function create() {
  return {
    from: null,
    to: null
  };
}
export default {
  create,
  ...ModelUtil.createAllValue('from'),
  ...ModelUtil.createAllValue('to')
};